import styled from 'styled-components';

const PropertySettingsWrapper = styled.div`
  .page-header-wrapper {
    padding: 20px 15px;
  }

  .page-title {
    color: #101828;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    margin: 0;
  }

  .settings-card {
    border: 1px solid #eaecf0;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
    border-radius: 12px;
    margin-bottom: 20px;

    .ant-card-head-title {
      color: #101828;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .section-description {
    color: #667085;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 20px;
  }

  .business-days-container {
    .ant-checkbox-wrapper {
      margin-right: 0;
      margin-bottom: 8px;
      color: #101828;
      font-weight: 500;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #0B2A1B;
      border-color: #0B2A1B;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner {
      border-color: #0B2A1B;
    }
  }

  .ant-divider {
    font-weight: 500;
    font-size: 16px;
    color: #101828;
  }

  .ant-form-item-label > label {
    color: #344054;
    font-weight: 500;
    font-size: 14px;
  }

  .save-button {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    font-weight: 600;
    border-radius: 8px;
    height: 40px;
    padding: 0 24px;
  }

  .save-button:hover,
  .save-button:focus {
    background-color: #0d3521;
    border-color: #0d3521;
  }

  .save-button:active {
    background-color: #092116;
    border-color: #092116;
  }

  .ant-picker {
    border-radius: 8px;
    border-color: #d0d5dd;
  }

  .ant-picker:hover,
  .ant-picker-focused {
    border-color: #0B2A1B;
  }

  .ant-picker-focused {
    box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1);
  }

  .ant-form-item-explain-error {
    margin-top: 8px;
    color: #f04438;
  }

  /* Loading spinner */
  .ant-spin-dot-item {
    background-color: #0B2A1B;
  }

  /* Responsive */
  @media only screen and (max-width: 768px) {
    .page-header-wrapper {
      padding: 15px 10px;
    }

    .page-title {
      font-size: 16px;
    }
  }
`;

export default PropertySettingsWrapper;
